import React from 'react';
import styled from 'styled-components';
import { IBreakdownFieldsFragment } from '../../../../utils/apollo/graphqlSchema';
import { getBinningDisplay } from '../../../../utils/binnings';
import { IndexedIcon } from '../../../Icon';
import * as BuilderInfoUI from '../../BuilderInfoUI';
import PredicateContent from '../PredicateContent';
import BuilderInfoLabelList from '../BuilderInfoLabelList';

const Container = styled.div`
  position: relative;
  flex-basis: 100%;
`;

const ConditionBracket = styled.div`
  flex: 0 0 auto;
  font-weight: 500;
`;

const InfoPopupBreakdownGroups = ({
  groupbys,
}: Pick<IBreakdownFieldsFragment, 'groupbys'>) => {
  return (
    <>
      {groupbys.map((group, index) => {
        const fieldName = group.field.name;

        const label = group?.bucketDef
          ? `${fieldName} { ${getBinningDisplay(group.bucketDef)} }`
          : fieldName;

        return (
          <Container key={`breakdown-group-popup-info-${index}`}>
            <BuilderInfoUI.HorizontalRow>
              <IndexedIcon
                name="breakdown"
                positiveIndex={index + 1}
                isActive={true}
              />
              <BuilderInfoLabelList items={[label]} />
            </BuilderInfoUI.HorizontalRow>
            {group?.predicate && (
              <BuilderInfoUI.HorizontalRow>
                <ConditionBracket>(</ConditionBracket>
                <PredicateContent predicate={group.predicate} index={index} />
                <ConditionBracket>)</ConditionBracket>
              </BuilderInfoUI.HorizontalRow>
            )}
          </Container>
        );
      })}
    </>
  );
};

export default InfoPopupBreakdownGroups;
